/** Import assets */

import { Helmet }           from "react-helmet-async";

import { useTranslation }   from "react-i18next";

import {
    hreflangLinks,
    localizedAbsoluteUrl,
    localizedValue,
    normalizeLanguage
}                           from "../../Components/SEO/localizedMeta";

import "../../Styles/Home.css";

/** Import components */

import HomeProductSearch    from "../../Components/Home/Search";

import HomeServices         from "../../Components/Home/Services";

import HomeBanner           from "../../Components/Home/Banner";

import HomeBlog             from "../../Components/Home/Blog";

import Benefits             from "../../Components/Home/Benefits";

import Categories           from "../../Components/Home/Categories";

import HomeStaticBanner     from "../../Components/Home/StaticBanner";

const Home = () => {

    const { i18n } = useTranslation();

    const currentLanguage = normalizeLanguage(i18n?.resolvedLanguage || i18n?.language);

    const canonicalHref = localizedAbsoluteUrl("/", currentLanguage);

    const alternateLinks = hreflangLinks("/");

    const pageTitle = localizedValue({
        lv: "Tireshop.lv | Riepas, diski, akumulatori un autoserviss",
        en: "Tireshop.lv | Tires, rims, batteries and car service",
        ru: "Tireshop.lv | Шины, диски, аккумуляторы и автосервис"
    }, currentLanguage);

    const pageDescription = localizedValue({
        lv: "Tireshop.lv lielākais riepu centrs un serviss ar vairāk nekā 30 000 riepu, disku un akumulatoru klāstu uz vietas. Labas cenas, plašs klāsts, ātrs serviss.",
        en: "Tireshop.lv is a large tire center and service with more than 30,000 tires, rims, and batteries in stock. Great prices, wide choice, fast service.",
        ru: "Tireshop.lv - крупный центр шин и сервиса: более 30 000 шин, дисков и аккумуляторов в наличии. Хорошие цены, большой выбор, быстрый сервис."
    }, currentLanguage);

    /** Render component */

    return (<div className="home">

        <Helmet>

            <title>{ pageTitle }</title>

            <meta
                name="description"
                content={ pageDescription }
            />

            <link rel="canonical" href={ canonicalHref } />

            { alternateLinks.map((item) => (
                <link
                    key={ item.hreflang }
                    rel="alternate"
                    hrefLang={ item.hreflang }
                    href={ item.href }
                />
            )) }

        </Helmet>

        <HomeProductSearch />

        <HomeStaticBanner />

        <Benefits />

        <Categories />

        <HomeServices />

        <HomeBanner />

        {/* <HomeSale />

        <HomeBanner />

        <HomeTeam /> */}

        <HomeBlog />

        {/* <LIAA /> */}

    </div>);

}

/** Export component */
 
export default Home;
